import { useEffect, useRef } from 'react';

const TERMINAL_ACTIVITY_EVENTS: (keyof WindowEventMap)[] = [
  'mousedown',
  'touchstart',
];

type UseTerminalAutoReturnHomeParams = {
  idleSeconds: number;
  isOnHomePage: boolean;
  onReturnHome: () => void;
  enabled?: boolean;
};

export const useTerminalAutoReturnHome = ({
  idleSeconds,
  isOnHomePage,
  onReturnHome,
  enabled = true,
}: UseTerminalAutoReturnHomeParams) => {
  const lastActivityRef = useRef(Date.now());
  const onReturnHomeRef = useRef(onReturnHome);

  useEffect(() => {
    onReturnHomeRef.current = onReturnHome;
  }, [onReturnHome]);

  useEffect(() => {
    if (!enabled || idleSeconds <= 0 || isOnHomePage) {
      return;
    }

    lastActivityRef.current = Date.now();

    const markActivity = () => {
      lastActivityRef.current = Date.now();
    };

    TERMINAL_ACTIVITY_EVENTS.forEach((event) =>
      window.addEventListener(event, markActivity, { passive: true }),
    );

    const timer = window.setInterval(() => {
      const elapsed = (Date.now() - lastActivityRef.current) / 1000;
      if (elapsed >= idleSeconds) {
        onReturnHomeRef.current();
        lastActivityRef.current = Date.now();
      }
    }, 1000);

    return () => {
      window.clearInterval(timer);
      TERMINAL_ACTIVITY_EVENTS.forEach((event) =>
        window.removeEventListener(event, markActivity),
      );
    };
  }, [enabled, idleSeconds, isOnHomePage]);
};
